// @flow

import ko from 'knockout';

ko.bindingHandlers.textInput = {
	init: function () {
		throw new Error("Use `value` binding instead of `textInput`");
	},
};
